import React, {useMemo} from 'react';
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {DivIcon, LatLng, LeafletEvent} from 'leaflet';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import LeafletMarker from '@ui/leafletCustom/leafletMarker/LeafletMarker';
import {LatLngCor} from "@ui/leafletCustom/types/latLng";
import {CustomPropertyPointMarkerSingleVoyage} from "@containers/singleVoyage/containers/points/cluster/types";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";
import {buildPointIconSingleVoyage} from "@containers/singleVoyage/containers/points/icon/buildPointIcon";
import {
    OnChangePositionMutateSingleVoyage,
    OnClickPointMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/types/events";
import {
    useCloseStopsSingleVoyage
} from "@containers/singleVoyage/containers/closeStops/useCloseStopsSingleVoyage";

// error.main of the theme; the marker is plain HTML, so the colour is written out
const CLOSE_STOP_BORDER_COLOR = '#d32f2f'


interface IProps {
    point: IWayPointCreationWithCorrectionsSingleVoyage,
    index: number,
    onChangePosition: OnChangePositionMutateSingleVoyage,
    onClickPoint: OnClickPointMutateSingleVoyage,
    disabled?: boolean
}

const PointOnTheMapMutateSingleVoyage = ({
                                             point,
                                             index,
                                             onClickPoint,
                                             onChangePosition,
                                             disabled,
                                         }: IProps) => {

    const {targetPointId} = useRootContextMutateSingleVoyage()
    const {conflictPointIds} = useCloseStopsSingleVoyage()
    const tooClose = conflictPointIds.has(String(point.id))

    const markerEventHandlers = useMemo(() => {
        if (point.status !== 'PLANNED') {
            return {
                click(e: LeafletEvent) {
                    onClickPoint(point)
                }
            }
        }
        return {
            async dragend(e: LeafletEvent) {
                const latLng = e.target.getLatLng()
                await onChangePosition({
                    point,
                    latLng: {lat: latLng.lat, lng: latLng.lng},
                })
            },
            click(e: LeafletEvent) {
                onClickPoint(point)
            }
        }
    }, [point, onClickPoint, onChangePosition])

    const options: {
        icon: DivIcon,
        latLng: LatLngCor,
        customProperty: CustomPropertyPointMarkerSingleVoyage
    } = useMemo(() => {
        const icon = buildPointIconSingleVoyage({
            name: point.name,
            number: index + 1,
            active: targetPointId?.toString() === point?.id?.toString(),
            borderColor: tooClose ? CLOSE_STOP_BORDER_COLOR : undefined,
        })
        const customProperty: CustomPropertyPointMarkerSingleVoyage = {
            ...point,
            number: index + 1,
            type: 'point_marker_single_voyage_point'
        }
        const {lat, lng} = getLatLngFromPointGeomCoordinates(point.geom)

        return {
            icon,
            latLng: new LatLng(lat, lng),
            customProperty

        }
    }, [index, point, targetPointId, tooClose])

    return (
        <LeafletMarker
            position={options.latLng}
            eventHandlers={markerEventHandlers}
            icon={options.icon}
            draggable={!disabled && point.status === 'PLANNED'}
            customProperty={options.customProperty}
        />
    );
};

export default PointOnTheMapMutateSingleVoyage;
